import type { MockProfile } from '@/data/mockProfiles';

/**
 * Live catalogue only.
 *
 * The feed, grid and landing must never be padded with `mockProfiles`.
 * Fake faces looking live blocks commercial trading.
 */
export const selectLiveCatalogue = (profiles: MockProfile[]): MockProfile[] =>
  profiles.filter((p) => p.photos.some((url) => Boolean(url)));

/** Featured hero from the live list, or null when the room is empty. */
export const pickFeaturedProfile = <T>(
  profiles: readonly T[],
  random: () => number = Math.random,
): T | null => {
  if (profiles.length === 0) return null;
  const index = Math.floor(random() * profiles.length);
  return profiles[index] ?? null;
};
